
const quantities = {};
const ACTIONS = {
  INCREASE: "increased",
  DECREASE: "decreased",
};
const SECTIONS = ["main-cart", "cart-drawer", "cart-bubble"];

function updateCart(line, quantityChange, action) {
  let currentQuantity = quantities[line];
  if (!currentQuantity) {
    console.error("Line item not found in quantities.");
    return;
  }

  let newQuantity =
    action === ACTIONS.INCREASE
      ? currentQuantity + quantityChange
      : currentQuantity - quantityChange;

  quantities[line] = newQuantity;

  document
    .querySelectorAll(`.product-quantity[data-line="${line}"] input`)
    .forEach((inputEl) => {
      inputEl.value = newQuantity;
    });

  const dataObj = {
    quantity: action === ACTIONS.DECREASE && newQuantity < 1 ? 0 : newQuantity,
    line: line,
    sections: [...SECTIONS, `${line}`],
    sections_url: window.location.pathname,
  };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataObj),
  })
    .then((response) => response.json())
    .then((data) => {
      if (action === ACTIONS.DECREASE && newQuantity < 1) {
        console.log("Removing product from cart.");
        delete quantities[line];
        removeExtraContainerDivs(data.sections);
        updateSections(data.sections);
        fetchAndUpdate();
      } else {
        console.log(`Product quantity ${action} successfully.`);
        removeExtraContainerDivs(data.sections);
        updateSections(data.sections);
      }
    })
    .catch((error) => {
      console.log(
        `There was an error ${action} the quantity of the item in the cart.`,
        error
      );
    });
}

// function bindEventHandlers() {
//   const badges = document.querySelectorAll(".best-seller__latest p");

//   if (badges.length === 0) return;

//   const speed = 20;

//   badges.forEach((badge) => {
//     const totalDistance = badge.offsetWidth;
//     const duration = totalDistance / speed;
//     badge.style.animationDuration = `${duration}s`;
//   });

//   const increaseButtons = document.querySelectorAll(".increase-quantity");
//   const decreaseButtons = document.querySelectorAll(".decrease-quantity");

//   increaseButtons.forEach((button) => {
//     button.removeEventListener("click", handleIncrease);
//     button.addEventListener("click", handleIncrease);
//   });

//   decreaseButtons.forEach((button) => {
//     button.removeEventListener("click", handleDecrease);
//     button.addEventListener("click", handleDecrease);
//   });
// }

function handleIncrease(event) {
  const line = event.currentTarget.getAttribute("data-line");
  updateCart(line, 1, "increased");
}

function handleDecrease(event) {
  const line = event.currentTarget.getAttribute("data-line");
  updateCart(line, 1, "decreased");
}

function removeExtraContainerDivs(sections) {
  for (const section in sections) {
    if (sections.hasOwnProperty(section)) {
      let sectionEl = document.createElement("div");
      sectionEl.innerHTML = sections[section];
      if (sectionEl.querySelector("#Cart-Drawer")) {
        sections[section] = sectionEl.querySelector("#Cart-Drawer").innerHTML;
      }
      if (sectionEl.querySelector(".product-quantity")) {
        sections[section] =
          sectionEl.querySelector(".product-quantity").innerHTML;
      }
    }
  }
}

function updateSections(sections) {
  const cartElement = document.getElementById("Cart");
  const cartDrawerElement = document.getElementById("Cart-Drawer");
  const cartDrawerToggleElement = document.getElementById("cart-drawer-toggle");

  if (sections["main-cart"] && cartElement) {
    cartElement.innerHTML = sections["main-cart"];
  }
  if (sections["cart-drawer"] && cartDrawerElement) {
    cartDrawerElement.innerHTML = sections["cart-drawer"];
  }
  if (sections["cart-bubble"] && cartDrawerToggleElement) {
    cartDrawerToggleElement.innerHTML = sections["cart-bubble"];
  }
}

function updateElementAttributes(newElem, targetElem) {
  Array.from(targetElem.attributes).forEach((attr) => {
    if (!newElem.hasAttribute(attr.name)) {
      targetElem.removeAttribute(attr.name);
    }
  });

  Array.from(newElem.attributes).forEach((attr) => {
    targetElem.setAttribute(attr.name, attr.value);
  });
}

function updateElementContent(newElem, targetElem) {
  updateElementAttributes(newElem, targetElem);

  const newNodes = Array.from(newElem.childNodes);
  const targetNodes = Array.from(targetElem.childNodes);

  for (let i = 0; i < newNodes.length || i < targetNodes.length; i++) {
    const newNode = newNodes[i];
    const targetNode = targetNodes[i];

    if (!targetNode) {
      targetElem.appendChild(newNode.cloneNode(true));
      continue;
    }

    if (!newNode) {
      targetElem.removeChild(targetNode);
      continue;
    }

    if (newNode.tagName === "IMG" && targetNode.tagName === "IMG") {
      continue;
    }

    if (
      newNode.nodeType !== targetNode.nodeType ||
      newNode.tagName !== targetNode.tagName
    ) {
      targetElem.replaceChild(newNode.cloneNode(true), targetNode);
      continue;
    }

    if (newNode.nodeType === Node.ELEMENT_NODE) {
      updateElementContent(newNode, targetNode);
    }
  }
}

function fetchAndUpdate() {
  const collectionHandle = document
    .querySelector("[data-collection-handle]")
    .getAttribute("data-collection-handle");
  fetch(`/collections/${collectionHandle}`)
    .then((response) => response.text())
    .then((data) => {
      let html_div = document.createElement("div");
      html_div.innerHTML = data;
      const sectionsResponse = html_div.querySelectorAll(
        ".collection-products__right"
      );
      const targetElements = document.querySelectorAll(
        ".collection-products__right"
      );

      if (sectionsResponse.length !== targetElements.length) {
        console.warn(
          "The number of sections on the page and in the response do not match"
        );
        return;
      }

      targetElements.forEach((targetElement, index) => {
        updateElementContent(sectionsResponse[index], targetElement);

        updateQuantities(targetElement, index);
        // bindEventHandlers();
        AOS.refreshHard();
      });
    })
    .catch((error) => console.error("Error:", error));
}

function updateQuantities(targetElement) {
  let productQuantities = targetElement.querySelectorAll(
    ".product-quantity-input"
  );
  productQuantities.forEach((element) => {
    let line = element.getAttribute("data-line");
    quantities[line] = Number(element.value);
  });
}

document.addEventListener("line-item:change:end", function (evt) {
  fetchAndUpdate();
});

document.addEventListener("cart:item-added", function (evt) {
  fetchAndUpdate();
});

fetchAndUpdate();

const inputs = document.querySelectorAll(".product-quantity-input");

inputs.forEach((element) => {
  element.addEventListener("keydown", function (e) {
    e.preventDefault();
  });
});
